import React from 'react';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import { pageTitle } from '../../helpers/PageTitle';


export default function PrivacyPolicy() {
  pageTitle('Privacy Policy');
  return (
    <>
      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title="Privacy Policy" />
      </Section>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="cs_blog_details">
              <h3>Effective Date: January 1st, 2025</h3>

              <h4>1. Introduction</h4>

              <p>Welcome to Estate Compass ("we," "our," "us"). We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our chatbot application designed to assist with estate settlement processes.</p>

              <h4>2. Information We Collect</h4>

              <p>We may collect and process the following types of information:
                <br /><br />
                <div className="cs_list cs_style_1">
                  <ul>
                    <li><b>Personal Information</b>: Includes names, contact details, dates of birth, social insurance numbers (SIN), social security numbers (SSN), and other identifiers related to the deceased and their family members.
                    </li>
                    <li><b>Estate Information</b>: Details about the deceased's estate, including assets, liabilities, wills, and other related documents.
                    </li>
                    <li><b>Usage Data</b>: Information about your interactions with our app, such as chat logs, access times, and device information.
                    </li>
                  </ul>
                </div>

              </p>

              <h4>3. How We Use Your Information</h4>

              <p>We use the collected information to:
                <br /><br />
                <div className="cs_list cs_style_1">
                  <ul>
                    <li>Provide and maintain our services.</li>

                    <li>Assist in the estate settlement process.</li>

                    <li>Improve, personalize, and expand our services.</li>

                    <li>Communicate with you, including responding to inquiries and providing updates.</li>

                    <li>Ensure compliance with legal obligations.</li>
                  </ul>
                </div>
              </p>

              <h4>4. Legal Basis for Processing Personal Information</h4>
              <p>
                We process personal information based on the following legal grounds:
                <br /><br />
                <div className="cs_list cs_style_1">
                  <ul>

                    <li><b>Consent</b>: By using our app, you consent to the collection and use of your information as described in this policy.</li>

                    <li><b>Legal Obligation</b>: Processing is necessary to comply with legal obligations related to estate settlement.</li>

                    <li><b>Legitimate Interests</b>: Processing is necessary for our legitimate interests, such as improving our services, provided these do not override your rights.</li>
                  </ul>
                </div>
              </p>
              <h4>5. Sharing Your Information</h4>
              <p>
                We may share your information with:
                <br /><br />
                <div className="cs_list cs_style_1">
                  <ul>

                    <li><b>Service Providers</b>: Third-party vendors who assist in providing our services, subject to confidentiality agreements.</li>

                    <li><b>Legal Authorities</b>: When required by law or to protect our rights.</li>

                    <li><b>Other Parties with Your Consent</b>: With your explicit consent, we may share information with other parties involved in the estate settlement process.</li>
                  </ul>
                </div>
              </p>

              <h4>6. Data Security</h4>

              <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>

              <h4>7. Data Retention</h4>

              <p>We retain personal information only for as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.</p>

              <h4>8. Your Rights</h4>
              <p>
                Depending on your jurisdiction, you may have the following rights regarding your personal information:
                <br /><br />
                <div className="cs_list cs_style_1">
                  <ul>

                    <li><b>Access</b>: Request access to the personal information we hold about you.</li>

                    <li><b>Correction</b>: Request correction of inaccurate or incomplete information.</li>

                    <li><b>Deletion</b>: Request deletion of your personal information, subject to certain exceptions.</li>

                    <li><b>Withdrawal of Consent</b>: Withdraw your consent to processing, where applicable.</li>
                  </ul>
                </div>
              </p>
              <p>
                To exercise these rights, please contact us at privacy AT myestatecompass.com.
              </p>
              <h4>9. Children's Privacy</h4>

              <p>
                Our services are not intended for individuals under the age of 16, and we do not knowingly collect personal information from children under 16 without proper authorization. However, in the context of estate settlement, we may process information about minor children as it pertains to the legal requirements or specific provisions of the deceased individual's estate. This information is collected solely for the purpose of fulfilling estate settlement obligations and is safeguarded in compliance with applicable laws.
              </p>
              <p>
                If you believe we have inadvertently collected unauthorized information about a minor or would like further clarification on how minor-related information is handled, please contact us at privacy AT myestatecompass.com. We will take appropriate steps to address the concern.
              </p>

              <h4>10. International Data Transfers</h4>

              <p>Your information may be transferred to and maintained on servers located outside of your jurisdiction, where data protection laws may differ. We take appropriate measures to ensure your data is treated securely.</p>

              <h4>11. Changes to This Privacy Policy</h4>

              <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the effective date.</p>

              <h4>12. Contact Us</h4>
              <p>

                If you have any questions or concerns about this Privacy Policy, please contact us at:
                <br /><br />
                Estate Compass - a division of Whirl Insights Inc.<br />
                1400 St-Louis, suite 104, Gatineau, QC, J8T 2N1<br />
                Email: privacy AT myestatecompass.com<br />
                Phone: 1-877-944-7555<br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
